import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';
import { BASENAME } from './config/constant';
import routes, { renderRoutes } from './routes';
import './index.css';
// import { Helmet } from 'react-helmet';

const App = () => {
    // useEffect(() => {
    //     console.log(routes);
    // }, []);
    return (
        <>
            {/* <Helmet>
                <meta
                    http-equiv="Content-Security-Policy"
                    content="default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self' data:; font-src 'self';"
                />
            </Helmet> */}

            <React.Fragment>
                <Router basename={BASENAME}>{renderRoutes(routes)}</Router>
            </React.Fragment>
        </>
    );
};

export default App;
